var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { Container, Card, CardBody } from 'reactstrap';
import { injectIntl } from 'react-intl';
import Signals from '../../../signals/Signals';
import { ApplicationContext } from '../../../ApplicationContext';
import CardTitleHeader from '../../components/ui/Cards/CardTitleHeader';
import CloseButton from '../../components/ui/CloseButton/CloseButton';
import ReportValueSettings from "./ReportValueSettings";
import ReportDataModel from "../../../models/ReportDataModel";
import ReportTable from "./ReportTable";
/**
 *
 */
var ReportTableOverlay = /** @class */ (function (_super) {
    __extends(ReportTableOverlay, _super);
    /**
     *
     * @param props
     */
    function ReportTableOverlay(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            reportDateModel: new ReportDataModel()
        };
        return _this;
    }
    /**
     *
     */
    ReportTableOverlay.prototype.componentDidMount = function () {
    };
    /**
     *
     */
    ReportTableOverlay.prototype.render = function () {
        var _a = this.props, intl = _a.intl, reportModel = _a.reportModel;
        var reportDateModel = this.state.reportDateModel;
        return React.createElement(Container, { className: 'report-table-overlay w-100 ' },
            React.createElement(Card, { className: "card--full-height bg-white" },
                React.createElement(CardTitleHeader, { title: reportModel.title }),
                React.createElement(CardBody, { className: "pb-0" },
                    React.createElement(ReportValueSettings, { reportModel: reportModel, reportDataModel: reportDateModel }),
                    React.createElement(ReportTable, { reportModel: reportModel, reportDataModel: reportDateModel }))),
            React.createElement(CloseButton, { onClick: function () {
                    Signals.HideOverlay.dispatch();
                } }));
    };
    ReportTableOverlay.defaultProps = {
        className: ''
    };
    ReportTableOverlay = __decorate([
        observer
    ], ReportTableOverlay);
    return ReportTableOverlay;
}(React.Component));
ReportTableOverlay.contextType = ApplicationContext;
export default injectIntl(ReportTableOverlay);
